import { Avatar, Box, Typography } from "@mui/material";
import CustomIcon from "components/CustomIcon";
import icons from "enums/icons";
import useStyles from "../Chatbot.styles";
import { useIntl } from "react-intl";

const ChatMessageOffline = () => {
    const classes = useStyles();
    const intl = useIntl();

    return (
        <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            height="100%"
            role="status"
        >
            <Avatar
                variant="circular"
                className={classes.avatarContainerSmall}
                sx={{ width: 117, height: 117, marginRight: "0px !important" }}
                aria-hidden
            >
                <CustomIcon icon={icons.eddyIcon} sx={{ width: 69, height: 69 }} />
            </Avatar>
            <Box mt={2} className={classes.statusTextOffline} textAlign="center">
                <Typography sx={{ fontSize: 18, fontWeight: 700 }}>
                    {intl.formatMessage({ id: "chatbot.offline.message01" })}
                </Typography>
                <Typography sx={{ fontSize: 18, fontWeight: 400 }}>
                    {intl.formatMessage({ id: "chatbot.offline.message02" })}
                </Typography>
            </Box>
        </Box>
    );
};

export default ChatMessageOffline;
